module.exports = __webpack_public_path__ + "52e9d873ae36f689063b871525807093.png";